import { z } from 'zod';
import { BaseStatFilterSchema } from '../../../schemas';
import { useProvincesChartQuery } from './useProvincesQuery';

interface UseProvincesChartParams {
	filters?: z.infer<typeof BaseStatFilterSchema>;
}

export const useProvincesChart = (params?: UseProvincesChartParams) => {
	const { data: nivoData, isLoading, error } = useProvincesChartQuery(params);

	return {
		nivoData: nivoData?.data || null,
		isLoading,
		error
	};
};
